module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Angel Prayer 1")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Stay by me ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("angel")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("uphold me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that my feet")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("don’t slip.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Teach me")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("to hymn the Holy")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("with resounding alleluias")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("from the heart")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("heavenly ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("as the angel-voices")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("all around me ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("that I hear.")]), _vm._v(" "), _c('p', {
    staticClass: "Note"
  }, [_vm._v("Prayer attributed to Johann Sebastian Bach")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd812b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-5.vue
// module id = 72
// module chunks = 0